import { render } from "./FavoritePagesLinks.vue?vue&type=template&id=498b94fe&scoped=true"
import script from "./FavoritePagesLinks.vue?vue&type=script&lang=js"
export * from "./FavoritePagesLinks.vue?vue&type=script&lang=js"

import "./FavoritePagesLinks.vue?vue&type=style&index=0&id=498b94fe&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498b94fe"]])

export default __exports__